import { IEditModifierGroupContext } from './editModifierGroupContext';

export enum EditModifierGroupActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_LOADER_STATUS = 'CHANGE_LOADER_STATUS',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	CHANGE_NAME_OF_MODIFIER_GROUP = 'CHANGE_NAME_OF_MODIFIER_GROUP',
	CHANGE_EXTERNAL_ID = 'CHANGE_EXTERNAL_ID',
	SET_DEFAULT_CUSTOMER_LANGUAGE = 'SET_DEFAULT_CUSTOMER_LANGUAGE',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: EditModifierGroupActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IEditModifierGroupContext['needRefetchData'];
	};
}

interface ISetAllData {
	type: EditModifierGroupActionTypes.SET_ALL_DATA;
	payload: {
		modifierGroupID: IEditModifierGroupContext['modifierGroupID'];
		initialIDSelectedCustomer: IEditModifierGroupContext['initialIDSelectedCustomer'];
		initialIDsSelectedRestaurant: IEditModifierGroupContext['initialIDsSelectedRestaurant'];
		nameOfModifierGroup: IEditModifierGroupContext['nameOfModifierGroup'];
		externalId: IEditModifierGroupContext['externalId'];
		articleNumber: IEditModifierGroupContext['articleNumber'];
		translations: IEditModifierGroupContext['translations'];
	};
}

interface IChangeLoaderStatus {
	type: EditModifierGroupActionTypes.CHANGE_LOADER_STATUS;
	payload: {
		isLoading: IEditModifierGroupContext['isLoading'];
	};
}

interface ISetFetchedCustomers {
	type: EditModifierGroupActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: IEditModifierGroupContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: EditModifierGroupActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IEditModifierGroupContext['IDSelectedCustomer'];
	};
}

interface ISetFetchedRestaurants {
	type: EditModifierGroupActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: IEditModifierGroupContext['fetchedRestaurants'];
	};
}

interface ISetIDsRestaurant {
	type: EditModifierGroupActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: IEditModifierGroupContext['IDsSelectedRestaurant'];
	};
}

interface IChangeNameOfModifierGroup {
	type: EditModifierGroupActionTypes.CHANGE_NAME_OF_MODIFIER_GROUP;
	payload: {
		nameOfModifierGroup: IEditModifierGroupContext['nameOfModifierGroup'];
	};
}

interface IChangeExternalId {
	type: EditModifierGroupActionTypes.CHANGE_EXTERNAL_ID;
	payload: {
		externalId: IEditModifierGroupContext['externalId'];
	};
}

interface ISetDefaultCustomerLanguage {
	type: EditModifierGroupActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE;
	payload: {
		defaultCustomerLanguage: IEditModifierGroupContext['defaultCustomerLanguage'];
	};
}

interface ISetTranslationTab {
	type: EditModifierGroupActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IEditModifierGroupContext['selectedTranslationTab'];
	};
}

interface IChangeTranslation {
	type: EditModifierGroupActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IEditModifierGroupContext['translations'];
	};
}

interface ISetDataForSubmit {
	type: EditModifierGroupActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditModifierGroupContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditModifierGroupActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditModifierGroupContext['typeOfModalWindow'];
	};
}

export type TEditModifierGroupAction =
	| IRefetchData
	| ISetAllData
	| IChangeLoaderStatus
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDsRestaurant
	| IChangeNameOfModifierGroup
	| IChangeExternalId
	| ISetDefaultCustomerLanguage
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
